module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/ranking-948478cb405cff57414183f0302f344d.png";